module.exports = __webpack_public_path__ + "img/strata-festival-hot-spot.a9780cb7.jpeg";